import _ from "lodash";
import ACLStore from "lib/aclStore";

import { getStaffListFromCache } from "SchoolLibrary/modules/GraphqlHelpers";
import { getMemoizedFunction } from "Utils";

const DEFAULT_STAFF_LIST_FILTERS = {
  archivalState: "ALL",
  searchText: "",
};

const getQueryVariablesAndFilters = ({
  organizationId,
  filters,
  grades,
  academicYears,
  createdBy,
  curriculumProgramIds,
  subjects,
  subjectsList = [],
  userArchivedFilters,
  collaboratorsFilter,
  isLearningCoursesEnabled,
}) => {
  const creatorListData = getStaffListFromCache({
    ...DEFAULT_STAFF_LIST_FILTERS,
    organizationId,
    curriculumProgramIds,
    userArchivedFilters,
  });

  const creatorList = _.get(creatorListData, "node.staff.edges");

  return {
    id: organizationId,
    filters: {
      searchText: filters.searchText,
      grades,
      academicYears,
      learningCourseIds: filters.learningCourseIds,
      classIds: filters.classIds,
      unitType: filters.unitType,
      /**
       * # Purpose of this size condition #
       * in unit plan library for the creator filter if we select all in filter then
       * all the creator which are currently part of org  will be given to backend for filter
       * but what if org want to access some unit which are created by some teacher who is not part of
       * org right now. So when all is selected for filter this condition will replace it with empty array so all
       * unit of that org will come regardless of creator whether it is part or org or not.
       * this will work like if no creator filter is applied.
       *
       * why size comparison work here ?
       * -> because createdBy is subset of creatorList
       */
      createdBy: _.size(createdBy) === _.size(creatorList) ? [] : createdBy,
      curriculumProgramIds,
      subjects: _.size(subjectsList) === _.size(subjects) ? [] : subjects,
      isUnitCodeSearchable: ACLStore.can("FeatureFlag:ShowUnitCode"),
    },
    showCollaborators: !isLearningCoursesEnabled,
    collaboratorsFilter,
    exceptionalCollaboratorsFilter: collaboratorsFilter,
  };
};

export const getQueryVariablesAndFiltersMemoized = getMemoizedFunction(
  getQueryVariablesAndFilters
);

export const getCourseList = ({ data }) => {
  return _.map(data, item => {
    const course = _.get(item, "node");
    const academicYears = _.get(course, "academicYears", []);

    const academicYearString =
      academicYears.length > 0
        ? academicYears
            .map(({ startDate, endDate }) => {
              const startYear = startDate?.split("-")[0];
              const endYear = endDate?.split("-")[0];
              return `${startYear}-${endYear}`;
            })
            .join(", ")
        : undefined;

    return {
      value: course.id,
      label: course.title,
      subText: academicYearString,
      isArchived: course.isArchived,
    };
  });
};
